/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Share_TitleInputs */

const en_mobile_referral_share_title = /** @type {(inputs: Mobile_Referral_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join me on Listening`)
};

const es_mobile_referral_share_title = /** @type {(inputs: Mobile_Referral_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a Listening conmigo`)
};

/**
* | output |
* | --- |
* | "Join me on Listening" |
*
* @param {Mobile_Referral_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_share_title = /** @type {((inputs?: Mobile_Referral_Share_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Share_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_share_title(inputs)
	return en_mobile_referral_share_title(inputs)
});